import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Navigate } from "react-router-dom";

import { Card, Grid, TextField } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

export default class AddAnnouncement extends Component {
  state = {
    title: "",
    message: "",
    notification: false,
    noticolor: "success",
    loading: false,
    redirect: false,
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    if (!this.state.title) {
      return this.setState({
        notification: true,
        message: "Title is required!",
        noticolor: "warning",
      });
    }

    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    const payload = {
      title: this.state.title,
      role_id: 1, // ✅ fixed
    };

    this.setState({ loading: true });

    try {
      const resp = await axios.post(
        Constants.postUrls.createAnnouncement,
        payload
      );

      this.setState({
        notification: true,
        message: resp.data.message || "Created successfully!",
        noticolor: "success",
        loading: false,
      });

      setTimeout(() => {
        this.setState({ redirect: true });
      }, 1500);
    } catch (err) {
      this.setState({
        notification: true,
        message:
          err?.response?.data?.message || "Something went wrong!",
        noticolor: "warning",
        loading: false,
      });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/announcements" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card style={{ padding: 20 }}>

            {/* 🔥 HEADER (YOUR RULE) */}
            <MDBox
              mx={2}
              mt={-6}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Add New Announcement
              </MDTypography>
            </MDBox>

            <form onSubmit={this.handleSubmit}>
              <Grid container spacing={2} mt={1}>

                {/* TITLE */}
                <Grid item sm={12}>
                  <TextField
                    label="Title"
                    name="title"
                    value={this.state.title}
                    onChange={this.handleInput}
                    fullWidth
                  />
                </Grid>

                {/* SUBMIT */}
                <Grid item sm={12}>
                  <MDButton type="submit" variant="contained" color="info">
                    {this.state.loading ? "Creating..." : "Create"}
                  </MDButton>
                </Grid>

              </Grid>
            </form>

          </Card>

          <MDSnackbar
            color={this.state.noticolor}
            title="Announcement"
            content={this.state.message}
            open={this.state.notification}
          />
        </MDBox>
      </DashboardLayout>
    );
  }
}